import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/recital-packages')({
  component: RecitalPackagesRoute,
});

function RecitalPackagesRoute() {
  return <Outlet />;
}
